import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useCallback } from 'react';

const fetchCatalogCustomOrder = async ({
  baseUrl,
  token,
  pathname,
}: {
  baseUrl: string;
  token?: string;
  pathname: string;
}) => {
  const response = await fetch(`${baseUrl}/${pathname}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
};

export function useCatalogCustomOrder() {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const fetchResponse = useCallback(async () => {
    const baseUrl = await discoveryApi.getBaseUrl('catalog-extensions');
    const pathname = 'catalog-custom-order';
    const { token } = await identityApi.getCredentials();

    return fetchCatalogCustomOrder({
      baseUrl,
      token,
      pathname,
    });
  }, [discoveryApi, identityApi]);

  return fetchResponse;
}
